<template>
  <div>

    <div id="myPaymentForm">
      <div class="kr-smart-form" kr-card-form-expanded kr-no-card-logo-header
        :kr-payment-method="lyra.get_accepted_payment_methods()"></div>
    </div>
  </div>
</template>

<script>
import KRGlue from "@lyracom/embedded-form-glue";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

export default {
  props: ["lyra"],
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  async mounted() {
    /* Use your endpoint and personal public key */
    var _this = this;


    const { KR } = await KRGlue.loadLibrary(this.lyra.endpoint, this.lyra.publicKey); /* Load the remote library */
    await KR.setFormConfig({
      /* set the minimal configuration */
      formToken: this.lyra.formToken,
      "kr-language": "fr-FR" /* to update initialization parameter */,
    });
    await KR.onSubmit((resp) => {
      if (_this.bookingStore) {
        _this.bookingStore.id_module = _this.mainStore.module.id;
        _this.bookingStore.transaction = _this.lyra;
      } else {
        _this.bookingStore = {};
        _this.bookingStore.id_module = _this.mainStore.module.id;
        _this.bookingStore.transaction = _this.lyra;
      }
      const hasTransactions = resp.clientAnswer.transactions?.[0] ? true : false;
      const orderStatus = resp.clientAnswer.orderStatus;
      const isIpWire = resp.clientAnswer.transactions[0] && resp.clientAnswer.transactions[0].paymentMethodType == "IP_WIRE";
      const has_preinscription = _this.mainStore.module.has_preinscription || _this.bookingStore.has_at_least_one_preinscription_selected;

      if (isIpWire) {
        if (orderStatus == "PAID" || orderStatus == "RUNNING") {
          _this.$router.push({ name: "CheckoutSuccess" });
        } else {
          _this.$router.push({ name: "CheckoutError" });
        }
      } else if (has_preinscription) {
        if (hasTransactions) {
          const transaction = resp.clientAnswer.transactions[0];
          const detailedStatus = transaction.detailedStatus;
          if (detailedStatus == "AUTHORISED" || detailedStatus == "WAITING_AUTHORISATION_TO_VALIDATE") {
            _this.$router.push({ name: "CheckoutSuccess" });
          } else {
            _this.$router.push({ name: "CheckoutError" });
          }
        }
        else {
          _this.$router.push({ name: "CheckoutError" });
        }
      } else {
        if (orderStatus == "PAID") {
          _this.$router.push({ name: "CheckoutSuccess" });
        } else {
          _this.$router.push({ name: "CheckoutError" });
        }
      }
    });
    await KR.renderElements("#myPaymentForm"); /* create a payment form */

    /* .then(({ KR }) => KR.renderElements("#myPaymentForm"))
      .then(({ KR, result }) => KR.showForm(result.formId));  */
  },
};
</script>

<style lang="scss">
.kr-smart-form {
  width: 100%;
}

.kr-smart-form .kr-smart-form-wrapper.kr-type-embedded .kr-smart-form-methods .kr-methods-list .kr-methods-list-options .kr-smart-form-list-section-name.kr-smart-form-list-section-name--other {
  color: white;
  font-size: 16px;
}
</style>
